import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { TrashView } from '~/components/files/trash-view'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/files/trash')({
  component: TrashRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Trash`) }] }),
})

function TrashRoute() {
  return <TrashView />
}
